export const BUTTON = 'button';

export const SCOPE = BUTTON;
